import { render, staticRenderFns } from "./ProjectViewXGrid.vue?vue&type=template&id=4b7d2e16&"
import script from "./ProjectViewXGrid.vue?vue&type=script&lang=ts&"
export * from "./ProjectViewXGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectViewXGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports